import { UserCircle, LayoutDashboard, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ManagerChoice = ({ user, onChoice }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-5xl">
        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-8 mb-8">
          <div className="flex items-center gap-4 mb-2">
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
              <UserCircle className="w-7 h-7 text-teal-600" />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Welcome Back</h1>
              <p className="text-sm text-gray-600" data-testid="manager-welcome-name">{user?.email}</p>
            </div>
          </div>
        </div>

        {/* Choice Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Your Account */}
          <button
            data-testid="choice-your-account"
            onClick={() => onChoice('account')}
            className="bg-white rounded-xl shadow-sm border-2 border-gray-200 hover:border-teal-500 hover:shadow-md transition-all duration-200 p-8 group text-left"
          >
            <div className="flex items-center justify-between mb-6">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                <UserCircle className="w-9 h-9 text-teal-600 group-hover:text-white transition-colors" />
              </div>
              <ChevronRight className="w-6 h-6 text-gray-400 group-hover:text-teal-600 group-hover:translate-x-1 transition-all" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Your Account</h2>
            <p className="text-gray-600">Manage your personal profile and settings</p>
          </button>

          {/* Managers Portal */}
          <button
            data-testid="choice-admin-panel"
            onClick={() => onChoice('admin')}
            className="bg-white rounded-xl shadow-sm border-2 border-gray-200 hover:border-purple-500 hover:shadow-md transition-all duration-200 p-8 group text-left"
          >
            <div className="flex items-center justify-between mb-6">
              <div className="w-16 h-16 bg-purple-100 rounded-xl flex items-center justify-center group-hover:bg-purple-600 transition-colors">
                <LayoutDashboard className="w-9 h-9 text-purple-600 group-hover:text-white transition-colors" />
              </div>
              <ChevronRight className="w-6 h-6 text-gray-400 group-hover:text-purple-600 group-hover:translate-x-1 transition-all" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Managers Portal</h2>
            <p className="text-gray-600">Access team management and admin tools</p>
          </button>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">Select a portal to continue</p>
        </div>
      </div>
    </div>
  );
};

export default ManagerChoice;
